import { propHasValue } from "../components/DynamicFormNew/helper.js";
import BaseService, { getProject } from "./BaseService.js";

class DashboardService extends BaseService {
  getCaddDashboard(options) {
    const config = {
      url: "/dashboard/cadd",
      params: {},
    };
    if (options) {
      Object.assign(config.params, { ...options });
    }
    return this.apiGet(config);
  }

  getCaddDashboardScp(options) {
    const config = {
      url: "/project/cadd/scproject",
      params: {},
    };
    if (options) {
      Object.assign(config.params, { ...options });
    }
    return this.apiGet(config);
  }

  getPmeDashboard(options) {
    const projectId = getProject();
    let sourceId = localStorage.getItem('source');

    if (sourceId === 'overview') {
      sourceId = null;
    }

    if (sourceId && projectId === 'myOwnData') {
      throw new Error('My own data should not have sourceId');
    }

    const config = {
      url: "/dashboard/pme",
      params: {},
    };
    if (projectId) {
      Object.assign(config.params, { project: projectId });
      if (sourceId && propHasValue(sourceId)) {
        Object.assign(config.params, { sourceId: sourceId });
      }
    }
    if (options) {
      Object.assign(config.params, { ...options });
    }
    return this.apiGet(config);
  }

  getPmeProject(options) {
    const projectId = getProject();

    const config = {
      url: `/dashboard/project/${projectId}`,
      params: {
      },
    };

    if (options) {
      Object.assign(config.params, { ...options });
    }

    return this.apiGet(config);
  }

  getTradeRelationShip(id) {
    const projectId = getProject();
    const sourceId = localStorage.getItem('source');
    const config = {
      url: `/dashboard/trade-relationship/${id}`,
      params: {},
    };
    if (projectId) {
      if (sourceId && propHasValue(sourceId)) {
        Object.assign(config.params, { sourceId: sourceId });
      }
    }
    return this.apiGet(config);
  }

  getSupplyChainMap(id, ignoreProject = false, sources = []) {
    const projectId = getProject();
    const sourceId = localStorage.getItem('source');
    const config = {
      url: `/dashboard/supply-chain-map/${id}`,
      params: {
        sources
      },
    };
    if (projectId) {
      if (sourceId && propHasValue(sourceId)) {
        Object.assign(config.params, { sourceId: sourceId });
      }
    } else if (ignoreProject) {
      Object.assign(config.params, { ignoreProject: true });
    }
    return this.apiGet(config);
  }
  getCaddSupplyChainMap(id, sources = []) {
    const config = {
      url: `/dashboard/supply-chain-map/${id}`,
      params: {
        sources
      },
    };
    return this.apiGet(config);
  }

  // Tazama
  getIndicators(partners) {
    return this.apiGet({
      url: '/tazama/dashboard/indicators',
      params: { sources: partners },
    });
  }

  getMap(partners) {
    return this.apiGet({
      url: '/tazama/dashboard/map',
      params: { sources: partners },
    });
  }

  getTimeline(partners, type, period) {
    return this.apiGet({
      url: `/tazama/dashboard/timeline/${type}`,
      params: { sources: partners, period },
    });
  }

  getDistribution(partners, type, period) {
    return this.apiGet({
      url: `/tazama/dashboard/distribution/${type}`,
      params: { sources: partners, period },
    });
  }

  getSolvers(partners, type, period) {
    return this.apiGet({
      url: `/tazama/dashboard/solvers/${type}`,
      params: { sources: partners, period },
    });
  }

  getTestimonials(partners) {
    return this.apiGet({
      url: `/tazama/dashboard/testimonials`,
      params: { sources: partners },
    });
  }
}

export default new DashboardService();
